import {unhideFireblocksVaultMutation} from "./graphql/unhideVault/mutations";
import {formatApolloError} from "./graphql/error";
import {client} from "./graphql/client";

export const unhideVaultDataProvider = {
    create: async(resource, params) => {
        const { customerId } = params;

        try {
            const result = await client.mutate({
                mutation: unhideFireblocksVaultMutation,
                variables: {
                    customerId
                }
            });

            const response = result.data;

            return {
                data: {
                    id: customerId,
                    result: response
                }
            }
        } catch (e) {
            return Promise.resolve({
                data: {
                    id: -1,
                    error: formatApolloError(e)
                }
            });
        }
    }
}